export default __webpack_public_path__ + "static/1-37-0-dancing-hog-b9b9dd3232c41746bea9c8a0667ebae8.gif";